// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"ao","goToRewardsLink":"bo","pointsSection":"co"};